import React from 'react';
import { useTranslation } from 'react-i18next';

const getBadgeProps = (state, t) => {
    switch (state?.toLowerCase()) {
        case 'draft':
            return { label: t('payslipStateBadge.draft'), className: 'bg-yellow-100 text-yellow-800' };
        case 'verify':
            return { label: t('payslipStateBadge.pending'), className: 'bg-yellow-100 text-green-800' };
        case 'done':
            return { label: t('payslipStateBadge.validated'), className: 'bg-green-100 text-green-800' };
        case 'refused':
            return { label: t('payslipStateBadge.refused'), className: 'bg-red-100 text-red-800' };
        case 'cancel':
            return { label: t('payslipStateBadge.cancelled'), className: 'bg-red-100 text-red-800' };
        default:
            return { label: state, className: 'bg-gray-100 text-gray-800' };
    }
};

const PayslipStateBadge = ({ state }) => {
    const { t } = useTranslation();
    if (!state) return null;
    const { label, className } = getBadgeProps(state, t);
    return (
        <span className={`px-2 py-1 rounded-full text-xs font-medium ${className}`}>
            {label}
        </span>
    );
};

export default PayslipStateBadge;